import {
  Avatar,
  Backdrop,
  Box,
  Grid,
  Slide,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import './styles.css';

type PropTypes = {
  type: 'win' | 'loss' | 'tie';
  playerMeAvatarUrl: string;
  playerThemAvatarUrl: string;
  winnerUsername: string;
};

export const Victory = ({
  playerMeAvatarUrl,
  playerThemAvatarUrl,
  type,
  winnerUsername,
}: PropTypes) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, 4000);
  }, []);

  const theme = useTheme();

  const bgcolor =
    type === 'win' ? theme.palette.underPar.main : theme.palette.secondary.main;

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={show}
    >
      <Box
        sx={{
          width: '800px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <Slide direction="right" in={show} timeout={700}>
          <Grid
            container
            sx={{
              padding: '0 50px',
              bgcolor: `${bgcolor}40`,
              boxShadow: `0 0 5px 1px ${bgcolor}, 0 0 2px 3px ${bgcolor} inset`,
            }}
          >
            <Grid item xs={2}>
              <Avatar
                src={playerMeAvatarUrl}
                variant="rounded"
                sx={{
                  filter: type === 'loss' ? 'grayscale(100%)' : '',
                  height: 100,
                  width: 100,
                  transform: 'translateY(-50%)',
                  position: 'relative',
                  top: '50%',
                }}
              ></Avatar>
            </Grid>
            <Grid item xs={8}>
              {type === 'win' ? (
                <Stack>
                  <Typography variant="h1">VICTORY!</Typography>
                  <Typography variant="h4" padding={2}>
                    {winnerUsername}
                  </Typography>
                </Stack>
              ) : type === 'loss' ? (
                <Stack>
                  <Typography variant="h1">DEFEAT</Typography>
                  <Typography variant="h6" padding={2}>
                    {winnerUsername} wins
                  </Typography>
                </Stack>
              ) : (
                <Stack>
                  <Typography variant="h1">DRAW!</Typography>
                </Stack>
              )}
            </Grid>
            <Grid item xs={2}>
              <Avatar
                src={playerThemAvatarUrl}
                variant="rounded"
                sx={{
                  filter: type === 'loss' ? '' : 'grayscale(100%)',
                  height: 100,
                  width: 100,
                  transform: 'translateY(-50%)',
                  position: 'relative',
                  top: '50%',
                  float: 'right',
                }}
              ></Avatar>
            </Grid>
          </Grid>
        </Slide>
      </Box>
    </Backdrop>
  );
};
